import React from 'react';
import { ShoppingBag, MessageCircle } from 'lucide-react';

interface FloatingDockProps {
  cartCount: number;
  onOpenCart: () => void;
  onToggleChat: () => void;
}

export const FloatingDock: React.FC<FloatingDockProps> = ({
  cartCount,
  onOpenCart,
  onToggleChat
}) => {
  return (
    <div className="fixed bottom-6 right-6 sm:right-8 md:right-10 flex flex-col items-center gap-3 z-50">
      {/* Support Chatbot Action Button */}
      <button
        onClick={onToggleChat}
        className="w-14 h-14 rounded-2xl bg-zinc-950/90 border border-white/10 hover:border-ninpo-lime/60 text-white hover:text-ninpo-lime shadow-[0_10px_30px_rgba(0,0,0,0.8)] flex items-center justify-center transition-all duration-300 hover:scale-110 active:scale-95 relative group backdrop-blur-md"
        aria-label="Open support chat"
      >
        <MessageCircle className="w-6 h-6 group-hover:rotate-12 transition-transform duration-300" />
      </button>

      {/* Cart Action Button */}
      <button
        onClick={onOpenCart}
        className="w-14 h-14 rounded-2xl bg-ninpo-black/90 border border-ninpo-lime/40 text-ninpo-lime shadow-[0_10px_30px_rgba(0,255,65,0.2)] flex items-center justify-center transition-all duration-300 hover:scale-110 active:scale-95 relative group backdrop-blur-md"
        aria-label="Open cart"
      >
        <ShoppingBag className="w-6 h-6 group-hover:scale-110 transition-transform duration-300" />
        {cartCount > 0 && (
          <span className="absolute -top-1.5 -right-1.5 min-w-[22px] h-5 px-1.5 rounded-full bg-red-600 text-white text-[10px] font-black flex items-center justify-center border border-ninpo-black animate-pulse shadow-[0_0_8px_rgba(220,38,38,0.8)]">
            {cartCount}
          </span>
        )}
      </button>
    </div>
  );
};

export default FloatingDock;
